<div class="card retrive-importacao-container">
    <div class="flex flex-wrap align-items-center justify-content-between gap-3 mb-3 retrive-importacao-header">
        <div>
            <h5 class="m-0">Importação de Dados (Retrive)</h5>
            <small class="text-color-secondary">Importe dados de variáveis através de arquivos CSV, XLSX ou XLS.</small>
        </div>
        <div class="flex flex-wrap justify-content-end gap-3 retrive-importacao-acoes">
            <button pButton pRipple type="button" label="Download Modelo CSV" icon="pi pi-download"
                class="p-button-secondary" (click)="baixarModeloCsv()">
            </button>
            <button pButton pRipple type="button" label="Download Modelo XLSX" icon="pi pi-file-excel"
                class="p-button-success" (click)="baixarModeloXlsx()">
            </button>
            <button pButton pRipple type="button" label="Análise por Período" icon="pi pi-chart-line"
                class="p-button-info" (click)="abrirModalAnalisePeriodo()">
            </button>
            <button pButton pRipple type="button" label="Nova Importação" icon="pi pi-upload"
                class="p-button-success" (click)="abrirWizard()">
            </button>
        </div>
    </div>

    <!-- Grid de Importações -->
    <div class="retrive-importacao-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loading"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['usuario.name', 'estacao.descricao', 'data_hora_importacao']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                <h5 class="m-0">Importações Realizadas</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>ID</th>
                <th>Estação</th>
                <th>Data/Hora Importação</th>
                <th>Usuário</th>
                <th style="width: 200px; text-align: center;">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <span class="p-column-title negrito">ID: </span>
                    {{item.id}}
                </td>
                <td>
                    <span class="p-column-title negrito">Estação: </span>
                    {{ nomeEstacao(item) }}
                </td>
                <td>
                    <span class="p-column-title negrito">Data/Hora: </span>
                    {{formatarDataHora(item.data_hora_importacao)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Usuário: </span>
                    {{item.usuario?.name || 'N/A'}}
                </td>
                <td style="text-align: center;">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple type="button" icon="pi pi-file-excel"
                        class="p-button-rounded p-button-success p-button-sm"
                        pTooltip="Exportar Comparativo" tooltipPosition="top"
                        (click)="exportarComparativo(item)">
                    </button>
                    <button pButton pRipple type="button" icon="pi pi-chart-line"
                        class="p-button-rounded p-button-info p-button-sm ml-2"
                        pTooltip="Ver Gráfico" tooltipPosition="top"
                        (click)="abrirModalGrafico(item)">
                    </button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" style="text-align: center;">
                    Nenhuma importação encontrada.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
</div>

<!-- Modal Wizard de Importação -->
<p-dialog header="Importar Dados" [(visible)]="mostrarWizard" [modal]="true"
    [style]="{width: '60rem'}" [breakpoints]="{'1199px': '80vw', '767px': '95vw'}"
    [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true" (onHide)="resetarImportacao()">

    <!-- Passo 1: Upload e Seleção de Estação -->
    <div *ngIf="passoWizard === 1" class="grid formgrid retrive-dialog-form">
        <div class="field field-label-top col-12 md:col-6">
            <label for="estacao">Estação *</label>
            <p-select inputId="estacao" appendTo="body" [options]="dropDownEstacoes" [fluid]="true"
                [(ngModel)]="estacaoSelecionada" [filter]="true" filterLocale="pt-BR"
                filterPlaceholder="Pesquisar estação" [showClear]="true" placeholder="Selecione a estação">
            </p-select>
        </div>

        <div class="field field-label-top col-12">
            <label>Arquivo (CSV, XLSX ou XLS) *</label>
            <p-fileUpload #fileUpload name="arquivo" [customUpload]="true" styleClass="w-full"
                [showUploadButton]="false" [showCancelButton]="false" [multiple]="false"
                accept=".csv,.xlsx,.xls" (onSelect)="onFileSelect($event)"
                (onRemove)="onFileRemove()" (onClear)="onFileRemove()"
                [auto]="false" [maxFileSize]="10000000"
                chooseLabel="Selecionar Arquivo">
                <ng-template pTemplate="empty">
                    <div class="flex align-items-center gap-2 text-color-secondary">
                        <i class="pi pi-cloud-upload"></i>
                        <span>Arraste o arquivo aqui ou clique em "Selecionar Arquivo".</span>
                    </div>
                </ng-template>
            </p-fileUpload>
        </div>

        <div class="col-12 flex justify-content-end gap-2 mt-2">
            <button pButton pRipple type="button" label="Próximo" icon="pi pi-arrow-right" iconPos="right"
                [disabled]="!arquivoSelecionado || !estacaoSelecionada || processandoArquivo"
                [loading]="processandoArquivo"
                (click)="irParaMapeamento()" class="p-button-primary">
            </button>
        </div>
    </div>

    <!-- Passo 2: Mapeamento de Colunas -->
    <div *ngIf="passoWizard === 2" class="grid formgrid retrive-dialog-form">
        <div class="col-12 mb-2">
            <h5 class="mb-1">Mapear Colunas do Arquivo para Tipos de Variável</h5>
            <small class="text-color-secondary">Selecione o tipo de variável correspondente a cada coluna de valor do arquivo.</small>
        </div>

        <div class="field field-label-top col-12 md:col-6 lg:col-4" *ngFor="let coluna of colunasValor; let i = index">
            <label [for]="'coluna-' + i" class="text-overflow-ellipsis overflow-hidden white-space-nowrap" [title]="coluna">{{coluna}}</label>
            <p-select [inputId]="'coluna-' + i" [options]="getOpcoesTipoVariavel(coluna)" appendTo="body" [fluid]="true"
                [(ngModel)]="mapeamentoColunas[coluna]" [filter]="true" [showClear]="true"
                filterPlaceholder="Pesquisar tipo" placeholder="Selecione o tipo de variável">
            </p-select>
        </div>

        <div class="col-12 flex justify-content-between gap-2 mt-2">
            <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                (click)="passoWizard = 1" class="p-button-secondary">
            </button>
            <button pButton pRipple type="button" label="Gerar Preview" icon="pi pi-eye"
                [disabled]="!mapeamentoValido()"
                (click)="gerarPreview()" class="p-button-primary">
            </button>
        </div>
    </div>

    <!-- Passo 3: Preview -->
    <div *ngIf="passoWizard === 3" class="grid retrive-dialog-form">
        <div class="col-12 mb-2">
            <h5 class="mb-1">Preview dos Dados</h5>
            <small class="text-color-secondary">
                Total de registros: {{previewData.length}} |
                Intervalo da estação: {{intervaloEstacao ? intervaloEstacao + ' minutos' : 'Não configurado'}}
            </small>
        </div>

        <div class="col-12">
            <p-table [value]="previewData.slice(0, 100)" [scrollable]="true" scrollHeight="400px"
                styleClass="p-datatable-sm p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Tipo Variável</th>
                        <th>Data/Hora</th>
                        <th>Valor</th>
                        <th>Status</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr [ngClass]="{'dado-existente': item._existente}">
                        <td>{{getTipoVariavelNome(item.tipo_variavel_id)}}</td>
                        <td>{{formatarDataHora(item.data_hora_dado)}}</td>
                        <td>{{item.valor}}</td>
                        <td>
                            <span *ngIf="item._existente" class="status-pill status-warn">Dado Existente (Será Substituído)</span>
                            <span *ngIf="!item._existente && item._faltante" class="status-pill status-warn">Dado Faltante (Zero)</span>
                            <span *ngIf="!item._existente && !item._faltante" class="status-pill status-success">OK</span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div class="col-12 flex justify-content-between gap-2 mt-3">
            <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                (click)="passoWizard = 2" class="p-button-secondary">
            </button>
            <button pButton pRipple type="button" label="Importar" icon="pi pi-check"
                [disabled]="loading" [loading]="loading" (click)="importar()" class="p-button-success">
            </button>
        </div>
    </div>
</p-dialog>

<!-- Modal de Análise por Período -->
<p-dialog header="Análise por Período" [(visible)]="modalAnalisePeriodo" [modal]="true"
    [style]="{width: '50rem'}" [breakpoints]="{'991px': '80vw', '767px': '95vw'}"
    [draggable]="false" [resizable]="false">

    <div class="grid formgrid retrive-dialog-form">
        <div class="field field-label-top col-12 md:col-7">
            <label for="estacaoAnalise">Estação *</label>
            <p-select inputId="estacaoAnalise" appendTo="body" [options]="dropDownEstacoes" [fluid]="true"
                [(ngModel)]="estacaoAnalise" [filter]="true" filterLocale="pt-BR"
                filterPlaceholder="Pesquisar estação" [showClear]="true" placeholder="Selecione a estação"
                (onChange)="carregarIntervaloOperacao()">
            </p-select>
        </div>

        <div class="field field-label-top col-12 md:col-5">
            <label for="periodoAnalise">Período *</label>
            <p-datepicker appendTo="body" dateFormat="dd/mm/yy" placeholder="Data inicial - Data final" [fluid]="true"
                [(ngModel)]="periodoAnalise" selectionMode="range" inputId="periodoAnalise" [showIcon]="true">
            </p-datepicker>
        </div>

        <div class="col-12 flex flex-wrap justify-content-end gap-2 mt-2">
            <button pButton pRipple type="button" label="Exportar Excel" icon="pi pi-file-excel"
                [disabled]="!estacaoAnalise || !periodoAnalise || periodoAnalise.length !== 2 || loading"
                (click)="exportarExcelPeriodo()" class="p-button-success">
            </button>
            <button pButton pRipple type="button" label="Ver Gráfico" icon="pi pi-chart-line"
                [disabled]="!estacaoAnalise || !periodoAnalise || periodoAnalise.length !== 2 || loading"
                (click)="abrirGraficoPeriodo()" class="p-button-info">
            </button>
        </div>
    </div>
</p-dialog>

<!-- Modal de Gráfico Comparativo -->
<p-dialog header="Gráfico Comparativo" [(visible)]="modalGrafico" [modal]="true"
    [style]="{width: '90vw', maxWidth: '1400px'}" [draggable]="false" [resizable]="false"
    (onHide)="fecharModalGrafico()">

    <div class="grid formgrid retrive-dialog-form" *ngIf="dadosComparativos && dadosComparativos['retrives']">
        <div class="field field-label-top col-12 md:col-6 lg:col-4">
            <label for="graficoVariavel">Tipo de Variável</label>
            <p-select inputId="graficoVariavel" [options]="dropDownTipoVariavel" appendTo="body" [fluid]="true"
                [(ngModel)]="graficoVariavelSelecionada" [filter]="true"
                (onChange)="criarGrafico()" placeholder="Selecione">
            </p-select>
        </div>

        <div class="col-12" style="height: 500px;">
            <div #chartContainer style="width: 100%; height: 100%;"></div>
        </div>
    </div>
</p-dialog>

<p-toast></p-toast>
